module.exports = __webpack_public_path__ + "static/official-logoAllWhite-15a0d0db23270030ad41f6f56f64fddf.svg";